export default __webpack_public_path__ + "static/media/add-program.22784040.svg";